// extracted by mini-css-extract-plugin
export default {"cls1":"ProfilePdfPackCard-cls1_Yqi","cls2":"ProfilePdfPackCard-cls2_ywv ProfilePdfPackCard-cls1_Yqi","pack-label":"ProfilePdfPackCard-pack-label_RFA"};